module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('strong', [_vm._v("Shipping Information")]), _c('br'), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-sm": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.addresses), function(address) {
    return _c('shipping-address', {
      key: address.id,
      attrs: {
        "address": address
      },
      on: {
        "edit": _vm.editAddressInfo,
        "delete": _vm.deleteAddressInfo
      }
    })
  }), _vm._v(" "), _c('add-card', {
    attrs: {
      "method": "edit",
      "value": _vm.defaultAddress
    },
    on: {
      "edit": _vm.editAddressInfo
    }
  }, [_vm._v("\n          Add Shipping Information\n        ")])], 2)], 1)], 1), _vm._v(" "), _c('shipping-address-form', {
    attrs: {
      "address": _vm.selectedAddress
    },
    on: {
      "update": function($event) {
        _vm.selectedAddress = $event
      },
      "save": _vm.saveAddressInfo,
      "close": function($event) {
        _vm.showShippingDialog = false
      },
      "delete": _vm.deleteAddressInfo
    },
    model: {
      value: (_vm.showShippingDialog),
      callback: function($$v) {
        _vm.showShippingDialog = $$v
      },
      expression: "showShippingDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9afbddc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/shipping-addresses.vue
// module id = 704
// module chunks = 1